// These are the settings specific to production mode

const DEFAULT_YOPLANNING_ROOT_URL = 'https://yoplanning.pro'; // No trailing slash !

// Both domains must be on same root domain !!
// left is booking engine domain, right is yoplanning domain
// similar map in yop prod settings
const CUSTOM_WHITELABEL_MAP = {
  'booking.destinationvoile-backoffice.com': 'destinationvoile-backoffice.com',
};

const getYoplanningRootUrl = () => {
  if (typeof window === 'undefined' || !window.location) return DEFAULT_YOPLANNING_ROOT_URL;
  if (CUSTOM_WHITELABEL_MAP[window.location.hostname] == null) return DEFAULT_YOPLANNING_ROOT_URL;
  return 'https://' + CUSTOM_WHITELABEL_MAP[window.location.hostname];
};

const YOPLANNING_ROOT_URL = getYoplanningRootUrl();

export const SETTINGS_PROD = {
  YOPLANNING_ROOT_URL: YOPLANNING_ROOT_URL,
  BOOKING_ENGINE_ROOT_URL: `${YOPLANNING_ROOT_URL}/booking-engine`, // No trailing slash !

  IS_DEV: false,
  SHOW_DEV_TOOLS: false,
  ROLLBAR_ENABLED: true,
  GTM_ENABLED: true,

  ROLLBAR_ENV_NAME: 'prod',
};
